import { Roles } from '@/entities/roles'
import { USER_ROLE_KEY } from '@/features/auth'
import { DisputStatusIcons, DisputStatusTitles } from '@/features/orders/model/constants'
import { DisputModel } from '@/features/orders/model/types'
import { getDisputAmount } from '@/features/orders/utils/getDisputAmount'
import { renderActionButton } from '@/features/orders/utils/renderActionButton'
import { BaseCopyButton } from '@/shared/components/BaseCopyButton/BaseCopyButton'
import { OrderIcon } from '@/shared/components/icons/OrderIcon'
import { ItemLayout } from '@/shared/components/ItemLayout/ItemLayout'
import { formatDate } from '@/shared/lib/date'
import { getStorageItem } from '@/shared/lib/storage/localStorage'
import { getShortenId } from '@/shared/utils/getShortenId'
import { useIsMobile } from '@/shared/utils/useIsMobile/useIsMobile'
import { formatCurrency } from '@/shared/lib'
import { Currencies } from '@/entities/curency'

type Props = {
  disput: DisputModel
  openDisputDialog: (id: string) => void
  topupAmount: string
}

export const OrderHeader = ({ disput, openDisputDialog, topupAmount }: Props) => {
  const isMobile = useIsMobile()
  const userRole = getStorageItem<Roles | null>(USER_ROLE_KEY, null)
  const isTrader = userRole === Roles.Trader

  const itemLayout = (
    <ItemLayout
      title={DisputStatusTitles[disput.status]}
      subtitle={
        isMobile ? (
          <div className="flex flex-col">
            <span>{formatDate(disput.createdAt, 'long')}</span>
            <div className="flex items-center gap-1">
              <span>ID сделки: {getShortenId(disput.paymentId, 'long')}</span>
              <BaseCopyButton text={disput.paymentId} color="secondary" size="mini" />
            </div>
          </div>
        ) : (
          `ID сделки: ${disput.paymentId}`
        )
      }
      icon={
        <OrderIcon
          status={DisputStatusIcons[disput.status]}
          className={isMobile ? 'w-[40px] h-[40px]' : 'w-[52px] h-[52px]'}
        />
      }
      titleClasses={isMobile ? 'text-[20px]' : 'text-[32px]'}
    />
  )

  const { disputAmountUSDT, disputAmountRub } = getDisputAmount(disput)

  return (
    <>
      {isMobile ? (
        <div className="flex justify-between text-sm">{itemLayout}</div>
      ) : (
        <>
          <div className="flex justify-between items-center">
            {itemLayout}
            <div className="flex flex-col items-end">
              <span className="text-[32px]">
                {formatCurrency(disputAmountUSDT, Currencies.USDT)}
              </span>
              <span className="text-text-secondary text-sm">Сумма сделки: {topupAmount}</span>
              <span className="text-text-secondary text-sm">
                Сумма спора: {formatCurrency(disputAmountRub, Currencies.RUB)}
              </span>
            </div>
          </div>
          {isTrader && renderActionButton({ disput, openDialog: openDisputDialog })}
        </>
      )}
    </>
  )
}
